import { render, staticRenderFns } from "./againAssess.vue?vue&type=template&id=0c59c892&scoped=true"
import script from "./againAssess.vue?vue&type=script&lang=js"
export * from "./againAssess.vue?vue&type=script&lang=js"
import style0 from "./againAssess.vue?vue&type=style&index=0&id=0c59c892&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c59c892",
  null
  
)

export default component.exports